import { Original } from 'components/common';
import get from 'lodash/get';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { getDropFromTokenId, tokenIdIsAnOriginal, tokenIdToOriginalId } from 'utils/token';
import useIdToOriginal from './useIdToOriginal';

const useActiveBeat = () => {
  const { id } = useParams<any>();
  const idToOriginal = useIdToOriginal();
  const [activeBeat, setActiveBeat] = useState<Original | null>(null);
  const [isPrint, setIsPrint] = useState<boolean>(false);

  useEffect(() => {
    if (!id) return;

    const drop = getDropFromTokenId(id);
    const isOriginal = tokenIdIsAnOriginal(drop, id);

    if (isOriginal) {
      setActiveBeat(get(idToOriginal, `${id}`, null));
    } else {
      const originalId = tokenIdToOriginalId(drop, id);
      setActiveBeat(get(idToOriginal, `${originalId}`, null));
    }

    setIsPrint(!isOriginal);
  }, [id, idToOriginal]);

  return {
    id,
    activeBeat,
    isPrint,
  };
};

export default useActiveBeat;
